import { FunctionComponent } from 'react';

import styled, { css } from 'styled-components';

import { colors } from 'chime-ui/system';

type LabelProps = {
  htmlFor: string;
  isEmpty?: boolean;
  isFocused?: boolean;
  isReadOnly?: boolean;
};

const Label: FunctionComponent<LabelProps> = styled.label`
  display: inline-block;
  color: ${colors.darkGrey};
  line-height: 1.25rem;
  margin: 0 0 5px;
  position: absolute;
  transition: 0.2s ease all;

  ${props =>
    props.isEmpty &&
    css`
      top: 22px;
      left: 13px;
      cursor: text;
    `}

  ${props =>
    (!props.isEmpty || props.isFocused) &&
    css`
      top: 0.5rem;
      left: 13px;
      font-size: 0.75rem;
    `};
`;

export default Label;
